import React from 'react'
import {Field, reduxForm} from 'redux-form';
import {connect} from 'react-redux';
import $ from 'jquery';
import {withRouter} from 'react-router-dom';
import {renderField, required} from '../../util/inputs';

export class ModalConfirmacaoNovoMapaVeiculo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selecaoTipoVeiculo: ''
    };
  }

  selecionarTipoVeiculo(tipo) {
    this.setState({ selecaoTipoVeiculo: tipo });
  }

  fecharModal () {
    $('#modalConfirmacaoNovoMapa')
      .modal('hide');
    $('#modalConfirmacaoNovoMapa')
      .hide();
    $('.modal-backdrop')
      .hide();
  }

  submit(values) {
    this.fecharModal();
    const { selecaoTipoVeiculo } = this.state;
    const doisAndares = selecaoTipoVeiculo === 'doisAndares';
    const umAndar = selecaoTipoVeiculo === 'umAndar';
    const embarcacao = selecaoTipoVeiculo === 'embarcacao';

    const url = `/painel-cadastro-mapa-veiculo?modeloVeiculo=${values.modeloVeiculo}&seDoisAndares=${doisAndares}&seUmAndar=${umAndar}&seEmbarcacao=${embarcacao}`;

    this.props.history.push(url);
  }

  limparMensagem () {
    this.setState({ mensagem: undefined })
  }

  render () {
    const { handleSubmit, submitting, invalid, pristine } = this.props;
    const { selecaoTipoVeiculo } = this.state;
    return (
      <div className="modal fade show" id='modalConfirmacaoNovoMapa' role='dialog'
           aria-labelledby='modalConfirmacaoNovoMapa' aria-hidden='true' data-backdrop='static'>
        <div className={'modal-dialog modal-dialog-centered modal-md'}>
          <div className="modal-content">
            <div className="modal-header">
              <h5>Novo mapa de veículo</h5>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close"
                      onClick={this.limparFormulario}>
                <i className="material-icons">
                  &#xe5cd;
                </i>
              </button>
            </div>
            <div className="modal-body">
              <form onSubmit={handleSubmit(this.submit.bind(this))}>
                <div className="form-row mb-4">
                  <div className="col-12 col-sm-9 col-md-12">
                    <Field name="modeloVeiculo" type="text" component={renderField} validate={[required]}
                           label="Modelo:"
                           css="form-control" readOnly={false}/>
                    <div className="btn-group mt-3 mr-2 mx-2" role="group">
                      <button type="button"
                              className={`btn btn-secondary mr-2 ${selecaoTipoVeiculo === 'umAndar' ? 'active' : ''}`}
                              onClick={() => this.selecionarTipoVeiculo('umAndar')}>
                        Um Andar
                      </button>
                      <button type="button"
                              className={`btn btn-secondary mr-2 ${selecaoTipoVeiculo === 'doisAndares' ? 'active' : ''}`}
                              onClick={() => this.selecionarTipoVeiculo('doisAndares')}>
                        Dois Andares
                      </button>
                      <button type="button"
                              className={`btn btn-secondary mr-2 ${selecaoTipoVeiculo === 'embarcacao' ? 'active' : ''}`}
                              onClick={() => this.selecionarTipoVeiculo('embarcacao')}>
                        Embarcação
                      </button>
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <button id="btn-confirmar-nome-mapa" type="submit" disabled={invalid || submitting || pristine}
                          className="btn btn-laranja">Confirmar
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(connect(null, {})(reduxForm({
  form: 'formCadastroMapaVeiculo',
  enableReinitialize: true,
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
})(ModalConfirmacaoNovoMapaVeiculo)));
